<template>
  <div class="document" style="position:relative;">
   <button @click="removeRecordClick">-</button>   {{textID}} <button @click="addFieldClick">+ Add Field</button><button @click="addImageClick">+ Add Image</button>
 
    <div v-for="(element,i) in sortedText" :key="'element'+i" class="padSide">
       <button @click="removeFieldClick(i)" >-</button>
  <EditableContent v-if="i!='image'" class="blackBG alignLeft" style="display:inline-flex; margin:3px;margin-left:5px;min-width:400px;" :collection="collection" :field="i" :textID="textID" :showField="true">
   </EditableContent> 
   <EditableImage v-if="i=='image'" class="blackBG alignLeft" style="display:inline-flex; margin:3px;margin-left:5px;min-width:400px;" :collection="collection" :field="i" :textID="textID" :showField="true">
   </EditableImage> 
   </div>
   <br><br>
  </div>
</template>

<script>
import EditableContent from '../components/EditableContent'
import EditableImage from '../components/EditableImage'
import Icon from '../components/Icon'

export default {
  components: {
    EditableContent,
    EditableImage
   
  },
  props: ["collection","textID","saveText"],
  data() {
    return {
      field:'body',
     
    }
  },
  mounted(){
       
    },
    computed:{
        sortedText(){
          let newObj={}
          var fields=[]
          let data=this.$store.getters.getTextElement({collection:this.collection,doc:this.textID})
          for(var obj in data){
            fields.push({type:obj,content:data[obj]})
          }
          fields=this.sortedArray(fields)
          for(var f in fields){
            newObj[fields[f].type]=fields[f].content
          }
          return newObj
        },
        textElement(){
            return this.$store.getters.getTextElement({collection:this.collection,doc:this.textID})
        },
       
        loading(){
            return this.$store.getters.loading
        },
       
      
    },
    methods:{
      sortedObject(obj){
          let newObj={}
          let keys=Object.keys(obj)
          keys=keys.sort(compare)
          for(var k in keys){
            newObj[keys[k]]=obj[keys[k]]
          }
          return newObj
          function compare(a, b) {
            if (a.type < b.type || a.type=="name")
              return -1;
            if (a.type > b.type &&  b.type!="name")
              return 1;
            return 0;
          }

      },
      sortedArray(array) {
    function compare(a, b) {
      if (a.type < b.type || a.type=="name")
        return -1;
      if (a.type > b.type &&  b.type!="name")
        return 1;
      return 0;
    }

    return array.sort(compare);
  },
      removeFieldClick(element){
        this.$store.commit('setShowPopup',{
        title:"Remove Field",
        subTitle:element,
        body:"Are you sure",
        btns:[{label:"no"},{label:"yes",action:this.removeField,param:element}]
        })
      },
      removeRecordClick(){
        this.$store.commit('setShowPopup',{
        title:"Remove Record",
        subTitle:this.collection+" "+this.textID,
        body:"Are you sure",
        btns:[{label:"no"},{label:"yes",action:this.removeRecord}]
        })
      },
      removeField(field){
        //alert("its gone "+field)
        this.$store.dispatch('removeField',{collection:this.collection,doc:this.textID,field:field})
 
      },
      removeRecord(record){
        //alert("its gone "+this.collection+" "+this.textID)
        this.$store.dispatch('removeDocument',{collection:this.collection,doc:this.textID})
      },
      addFieldClick(){
      this.$store.commit('setShowPopup',{
        title:"Add Field",
        subTitle:this.collection+" "+this.textID,
        input:"Enter Field Name",
        btns:[{label:"cancel"},{label:"add",action:this.addField}]
        })     
      },
      addImageClick(){
        this.$store.commit('setShowImageLoader',{callback:this.addImage,imagePath:this.collection})
      },
      addImage(fName,file,metadata){
       
         this.$store.dispatch("addField",{collection:this.collection,doc:this.textID,field:'image',content:fName+"|"+file})
         console.log(metadata)
         this.$store.dispatch("addField",{collection:this.collection,doc:this.textID,field:'image-size',content:metadata.width+","+metadata.height})
         
   
      },
      addField(param){
         this.$store.dispatch("addField",{collection:this.collection,doc:this.textID,field:param,content:"-------"})
      },
      textContent(field){
            if(this.textElement){
                return this.textElement[field]
            }
        },
      doSave(html){
          if(this.saveText){
              this.saveText(html)
          }else if(this.textID){
            this.$store.dispatch("saveText",{collection:this.collection,doc:this.textID,content:html})
          }
      },
      hideMenu(){
        if(!this.focused){
          this.showMenu=false
        }

      }

    },
    watch:{
      
    },
  beforeDestroy() {
    
    
  },
}
</script>
<style>


</style>